




import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AddProduct from "./admin/AddProduct";
import ProductsPage from "./Component/ProductsPage";
import ProductDetailsPage from "./Component/ProductDetailsPage";
import CartPage from "./Component/CartPage";
import HomePage from "./Component/HomePage";
import CheckoutPage from "./Component/CheckoutPage";
import OrderConfirmation from "./Component/OrderConfirmation ";
import OrderDetails from "./Component/OrderDetails";
import AdminDashboard from "./admin/AdminDashboard";
import UserManager from "./admin/UserManager";
import Login from "./Component/Login";
import { AuthProvider } from "./AuthContext";
import WatchesPage from "./Component/WatchesPage";
import SunglassesPage from "./Component/SunglassesPage";
import AccessoriesPage from "./Component/AccessoriesPage";
import AdminOrders from "./admin/AdminOrders";
import OrderDetailsPage from "./Component/OrderDetailsPage";
import AdminSlider from "./admin/AdminSlider";
import ProtectedRoute from "./ProtectedRoute";
import Footer from "./Component/Footer"; // Import Footer
import ShippingPolicy from "./Component/ShippingPolicy"; // Import ShippingPolicy
import PrivacyPolicy from "./Component/PrivacyPolicy"; // Import PrivacyPolicy
import ReturnsExchanges from "./Component/ReturnsExchanges"; // Import ReturnsExchanges
import CancellationPolicy from "./Component/CancellationPolicy"; // Import CancellationPolicy
import ContactUs from "./Component/ContactUs"; // Import ContactUs
import TermsAndConditions from "./Component/TermsAndConditions"; // Import TermsAndConditions

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />          
          <Route path="/Products" element={<ProductsPage />} />
          <Route path="/watches" element={<WatchesPage />} />
          <Route path="/sunglasses" element={<SunglassesPage />} />
          <Route path="/accessories" element={<AccessoriesPage />} />
          <Route path="/product/:productId" element={<ProductDetailsPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/orders" element={<OrderDetails />} />
          <Route path="/order-details/:orderId" element={<OrderDetailsPage />} />
          <Route path="/Footer" element={<Footer />} />
          <Route path="/ReturnsExchanges" element={<ReturnsExchanges />} />
          <Route path="/ShippingPolicy" element={<ShippingPolicy />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
           <Route path="/CancellationPolicy" element={<CancellationPolicy />} />
           <Route path="/ContactUs" element={<ContactUs />} />
           <Route path="/TermsAndConditions" element={<TermsAndConditions />} />

          {/* Protected Admin Routes */}
          <Route 
            path="/AdminDashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
       
                 <Route 
            path="/AddProduct" 
            element={
              <ProtectedRoute >
                <AddProduct />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/AdminOrders" 
            element={
              <ProtectedRoute >
                <AdminOrders />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/AdminSlider" 
            element={
              <ProtectedRoute >
                <AdminSlider />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/UserManager" 
            element={
              <ProtectedRoute >
                <UserManager />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;